import { render, staticRenderFns } from "./right-fixed.vue?vue&type=template&id=5c20f532&scoped=true&"
import script from "./right-fixed.vue?vue&type=script&lang=js&"
export * from "./right-fixed.vue?vue&type=script&lang=js&"
import style0 from "./right-fixed.vue?vue&type=style&index=0&id=5c20f532&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c20f532",
  null
  
)

export default component.exports